module.exports = __webpack_public_path__ + "bed-button-share.17dbe3c1.png";